var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.sources.length)?_c('div',{staticClass:"C-article__sources"},_vm._l((_vm.sources),function(source,index){return _c('div',{key:index,staticClass:"C-article-source"},[_c('div',{staticClass:"C-article-source__description"},[_vm._v(_vm._s(source.name))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }